var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('numbering-check-settings',{attrs:{"model-name":"saleinvoice","document-label":"le fatture di vendita"}})}
var staticRenderFns = []

export { render, staticRenderFns }